module.exports = __webpack_public_path__ + "static/media/traveloka-logo-icon.85e5e93a.png";